export const UPDATE_SELECTORDERPRICE = "UPDATE_SELECTORDERPRICE";

export function updateSelectOrderPrice(theme) {
    return {
        type: UPDATE_SELECTORDERPRICE,
        payload: theme
    };
}
